import { render, staticRenderFns } from "./Agb.vue?vue&type=template&id=3c7fa1d8&scoped=true"
import script from "./Agb.vue?vue&type=script&lang=js"
export * from "./Agb.vue?vue&type=script&lang=js"
import style0 from "./Agb.vue?vue&type=style&index=0&id=3c7fa1d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7fa1d8",
  null
  
)

export default component.exports